import * as yup from 'yup';
import { axios } from '../../utils/axios';
import { toast } from 'react-toastify';
import { toastOptions } from '../../config/toast';
import { axiosFotoMulta } from '../../utils/axiosFotoMulta';

export const onSubmitBuscarRecibo = async (submittedData, setRecibo, setIsLoading) => {
  setIsLoading(true);

  let result;
  if (submittedData.numero_acta.trim().split('-')[0].toUpperCase() !== 'MVD') {
    result = await axios().post('/obtener_recibo', submittedData);
  } else {
    result = await axiosFotoMulta().post('/obtener_recibo_foto_multa', submittedData); 
  }

  const { status } = result;
  const { data, error } = result.data;

  if (data) {
    if (data === 'El recibo se encuentra vencido') {
      toast.error(`El recibo para el pago del acta ${submittedData.numero_acta} ha vencido`, toastOptions);
    } else {
      setRecibo(data);
    }
  }

  if (error) {
    if (status !== 422) {
      toast.error(error, toastOptions);
    } else {
      Object.values(error).map((err) => toast.error(err[0], toastOptions));
    }
  }

  setIsLoading(false);
};

export const buscarReciboPorParams = async (numeroDeActa, dependencia, setRecibo, navigate) => {
  const numero_acta = dependencia + '-' + numeroDeActa;

  /* if (dependencia?.toUpperCase() !== 'DTM' && dependencia?.toUpperCase() !== 'DTP') {
    return;
  } */

  const result = await axios().post('/obtener_recibo', { numero_acta });
  const { status } = result;
  const { data, error } = result.data;

  if (data) {
    if (data === 'El recibo se encuentra vencido') {
      toast.error(`El recibo para el pago del acta ${numero_acta} ha vencido`, toastOptions);
    } else {
      setRecibo(data);
    }
  }

  if (error) {
    if (status !== 422) {
      toast.error(error, toastOptions);
    } else {
      Object.values(error).map((err) => toast.error(err[0], toastOptions));
    }
    navigate('/pagar')
  }
};

export const numeroActaSchema = yup.object({
  numero_acta: yup
    .string()
    .required('Numero de acta requerido')
    .matches(/^(DTP|DTM|MVD)-(?!0+$)[0-9]+$/i, { message: 'Formato incorrecto', excludeEmptyString: true }),
  documento_titular: yup
    .string()
    .when("numero_acta", {
      is: (value) => value.trim().split('-')[0].toUpperCase() === 'MVD',
      then: (schema) =>
        schema
          .required("Documento o CUIT del titular del vehículo requerido")
          .matches(
            /^(?!0)([0-9]){6,11}$/,
            "El Documento o CUIT debe contener entre 6 y 11 numeros, y no puede comenzar con 0"
          ),
      otherwise: (schema) => schema.nullable().notRequired(),
    })
});
